export const columnHeaders = [
  'period',
  'taxaccounting',
  'enabledflag',
  'p&l',
  'balancesheet',
  'reclassp&l',
  'reclassbalancesheet',
  'goldid',
];
